import { render } from "./AddTypeNotificationModal.vue?vue&type=template&id=8873d156&ts=true"
import script from "./AddTypeNotificationModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeNotificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__